class MacornerProductController {
  constructor(sectionRoot) {
    this.sectionRoot = sectionRoot;
    this.mediaShell = sectionRoot.querySelector('.mac-product-media-shell');
    this.accordionDetails = Array.from(sectionRoot.querySelectorAll('.mac-product-accordions details'));

    if (!this.mediaShell || this.accordionDetails.length === 0) return;

    this.updateStickyOffset = this.updateStickyOffset.bind(this);
    this.handleToggle = this.handleToggle.bind(this);

    this.accordionDetails.forEach((detailsElement) => {
      detailsElement.addEventListener('toggle', this.handleToggle);
    });

    this.updateStickyOffset();
    window.addEventListener('resize', this.updateStickyOffset, { passive: true });
  }

  getStickyHeaderOffset() {
    const stickyHeaderElement = document.querySelector('sticky-header');
    return stickyHeaderElement ? stickyHeaderElement.offsetHeight : 0;
  }

  updateStickyOffset() {
    this.sectionRoot.style.setProperty('--header-height', `${this.getStickyHeaderOffset()}px`);
  }

  handleToggle(event) {
    const detailsElement = event.currentTarget;

    if (!detailsElement.open) return;

    const summaryElement = detailsElement.querySelector('summary');
    const contentElement = detailsElement.querySelector('.accordion__content');

    if (!summaryElement || !contentElement) return;

    requestAnimationFrame(() => {
      const stickyOffset = this.getStickyHeaderOffset();
      const viewportPadding = window.innerWidth < 750 ? 14 : 24;
      const summaryRect = summaryElement.getBoundingClientRect();
      const contentRect = contentElement.getBoundingClientRect();
      const visibleBottom = window.innerHeight - viewportPadding;
      const shouldScroll =
        summaryRect.top < stickyOffset + viewportPadding || contentRect.bottom > visibleBottom;

      if (!shouldScroll) return;

      const targetTop = window.scrollY + summaryRect.top - stickyOffset - viewportPadding;

      window.scrollTo({
        top: Math.max(targetTop, 0),
        behavior: 'smooth',
      });
    });
  }
}

const initMacornerProducts = () => {
  // Random review count with localStorage persistence
  document.querySelectorAll('[data-random-review]').forEach((el) => {
    const productId = el.dataset.productId;
    const min = parseInt(el.dataset.min, 10);
    const max = parseInt(el.dataset.max, 10);
    const key = `mac_review_count_${productId}`;

    let count = localStorage.getItem(key);
    if (count === null) {
      count = Math.floor(Math.random() * (max - min + 1)) + min;
      localStorage.setItem(key, count);
    } else {
      count = parseInt(count, 10);
    }

    el.textContent = `${count.toLocaleString()} reviews`;
  });

  document.querySelectorAll('[data-macorner-product]').forEach((sectionRoot) => {
    if (sectionRoot.dataset.macornerProductInitialized === 'true') return;

    sectionRoot.dataset.macornerProductInitialized = 'true';
    new MacornerProductController(sectionRoot);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMacornerProducts, { once: true });
} else {
  initMacornerProducts();
}

document.addEventListener('shopify:section:load', initMacornerProducts);
